import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    CircularProgress,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    Snackbar,
    Switch,
    TextField,
    Typography
} from "@mui/material";
import {formatDate, moment, nullToEmptyString} from "../../helpers";
import LoadingProgress from "../../components/LoadingProgress";
import makeStyles from '@mui/styles/makeStyles';
import {DateInput, SelectSmart} from "../../components/CustomTextField";
import {getAdminEnums, getAppUsersById, putAppUser} from "../../services";

import Strings from "../../assets/strings";
import {SelectPais} from "../../components/selects";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import {Launch, WhatsApp} from "@mui/icons-material";
import StyledCheckbox from "../../components/StyledCheckbox";
import {updateAppUser} from "../../redux/reducers/appUsersReducers";
import {useAppDispatch} from "../../redux/hooks";
import {IAppUser, IUserEnum} from "../../redux/types/IAppUser";
import {useParams} from "react-router-dom";
import {AppBar} from "../../components";

const useStyles = makeStyles(theme => ({
    topControls:{
        display: "flex",
        marginBottom: 14,
        borderBottom: "1px solid #e8d8d8",
        alignItems: "center",
        justifyContent: "space-between",
    }

}));

const initialState:IAppUser={
    id:undefined,
    tipoPlan:undefined,
    // usuTipo:"",
    // usuInicioSesion:"-",
    nombre:"",
    email:"",
    titularEmail:"",
    telefono:"",
    clientesActivos:0,
    prestamosActivos:0,
    pagosRealizados:0,
    fechaUltimoPago:"",
    tipoAviso:undefined,
    maxPrestamos:0,
    maxAgentes:0,
    maxCajas:0,
    agentes:0,
    paisId:undefined,
    fechaCreacion:"",
    inactivo:false,
    maxContratos:0,
    maxRutas:0,
    // usuMaster:"",
    estado:1,
    comentario:"",
    suscriptionId:"",
    cuentaDestino:"",
    modulos:[],
    proximoPago: moment().format("YYYY-MM-DD"),
    //facturacion:[]
};


export default function Editar({urlUsuId: id, onClose}:{urlUsuId?:number,onClose:any}) {
    const Dispatch = useAppDispatch();
    let { usuId} = useParams()
    let urlUsuId = +(usuId || id || 0);

    const [openSnackbar, setOpenSnackbar] = React.useState(false);

    const classes = useStyles();
    const [state, setState] = useState(initialState);
    const [adminEnums, setAdminEnums] = useState<IUserEnum>({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if(urlUsuId){
            getAppUsersById(urlUsuId).then((res)=>{
                setState(state=>({...state,...nullToEmptyString(res?.data)}));
            }).finally(()=>setLoading(false))
        }
    }, [setState, urlUsuId]);
    useEffect(()=>{
        getAdminEnums().then(({data})=>{
            setAdminEnums(data);
        })
    },[])
    const handleChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        const {name, value, type, checked} = e.target;
        setState({...state,[name]: (type === "checkbox") ? checked: value})
    };

    const handleModuloCheck  = ({key,checked}:{key:number,checked:boolean})  => {
        let modulos = [...(state.modulos??[])]

        if(checked) {
            modulos.push({modulo: key});
        }else {
            modulos = modulos?.filter(item => item.modulo !== key);
        }

        setState({...state,modulos});
    };

    const handleSubmit = (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true)
        let object = {
            tenantId:state.tenantId,
            inactivo:state.inactivo,
            estado:state.estado,
            id:state.id,
            tipoPlan:state.tipoPlan,
            email:state.email,
            titularEmail:state.titularEmail,
            telefono:state.telefono,
            tipoAviso:state.tipoAviso,
            maxPrestamos:state.maxPrestamos,
            maxAgentes:state.maxAgentes,
            maxCajas:state.maxCajas,
            maxContratos:state.maxContratos,
            maxRutas:state.maxRutas,
            nombre:state.nombre,
            comentario:state.comentario,
            paisId:state.paisId,
            suscriptionId:state.suscriptionId,
            cuentaDestino:state.cuentaDestino,
            modulos:state.modulos??[],
            proximoPago:state.proximoPago
        }
        putAppUser(object).then(({data})=>{
            Dispatch(updateAppUser(data))
            //setState(state=>({...state,...nullToEmptyString(data)}));
            setOpenSnackbar(true)
        }).finally(()=>{
            setLoading(false)
        })
    };

    // const usuTipo = adminEnums?.tiposUsuario?.find(e=> parseInt(e.key) === state.usuTipo);
    return <>
    {!!usuId &&
        <AppBar title={"APP usuarios"} />
    }
        <Box p={!!usuId ? 2: 0}>
            <div className={classes.topControls}>
                <div>
                    <Typography color={"primary"} variant={"h6"}>{state.nombre}</Typography>
                </div>
                <div>
                    <Button onClick={onClose}>{Strings.cancelar}</Button>
                    <Button color="inherit" disabled={loading} type="submit" form="form1" value="Submit">
                        {loading? (
                            <span><CircularProgress size={14} color="inherit" /> &nbsp; {Strings.cargando}</span>
                        ):(
                            <span>{Strings.guardar}</span>
                        )}
                    </Button>
                </div>
            </div>
                {loading && <LoadingProgress vh/>}
            <form id="form1" onSubmit={handleSubmit} autoComplete="off">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormControlLabel  sx={{margin: 0}}
                                           control={
                                               <Switch
                                                   // size={"small"}
                                                   name={"inactivo"}
                                                   checked={state.inactivo}
                                                   onChange={handleChange}
                                                   // value="checkedB"
                                               />
                                           }
                                           label={Strings.inactivo}
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <FormControl fullWidth>
                            <InputLabel shrink>Aviso</InputLabel>
                            <SelectSmart
                                fullWidth
                                value={state.tipoAviso}
                                onChange={handleChange}
                                name={"tipoAviso"}
                                opciones={adminEnums["tiposAviso"] ? [{key:"",value:"Selelccione"},...adminEnums["tiposAviso"]]:[]}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <FormControl fullWidth>
                            <InputLabel shrink>Plan</InputLabel>
                            <SelectSmart
                                fullWidth
                                value={state.tipoPlan}
                                onChange={handleChange}
                                name={"tipoPlan"}
                                opciones={adminEnums["planes"] ? adminEnums["planes"]:[]}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <TextField
                            name="maxPrestamos"
                            value={state.maxPrestamos}
                            label="Max Préstamos"
                            onChange={handleChange}
                            type={"number"}
                            fullWidth
                        />

                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>

                        <TextField
                            name="maxAgentes"
                            value={state.maxAgentes}
                            label="Max Agentes"
                            onChange={handleChange}
                            type={"number"}
                            fullWidth
                        />

                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <TextField
                            name="maxCajas"
                            value={state.maxCajas}
                            onChange={handleChange}
                            label="Max Cajas"
                            type={"number"}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <TextField
                            name="maxRutas"
                            value={state.maxRutas}
                            onChange={handleChange}
                            label="Max Rutas"
                            type={"number"}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <TextField
                            name="maxContratos"
                            value={state.maxContratos}
                            onChange={handleChange}
                            label="Max Contratos"
                            type={"number"}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <FormControl fullWidth>
                            <InputLabel shrink>Estado</InputLabel>
                            <SelectSmart
                                fullWidth
                                value={state.estado?.toString() ?? undefined}
                                onChange={handleChange}
                                name={"estado"}
                                opciones={adminEnums["estadosCompania"] ? adminEnums["estadosCompania"]:[]}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <SelectPais
                            name="paisId"
                            display={"descripcion"}
                            label={"País"}
                            value={state.paisId}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <TextField
                            name="nombre"
                            label={Strings.nombres}
                            value={state.nombre}
                            onChange={handleChange}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <TextField
                            name="email"
                            value={state.email}
                            onChange={handleChange}
                            label={Strings.email}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <TextField
                            name="titularEmail"
                            value={state.titularEmail ?? ""}
                            onChange={handleChange}
                            label={Strings.email+" titular"}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="standard-adornment-password">{Strings.telefono}</InputLabel>
                            <Input
                                id="standard-adornment-password"
                                type={"tel"}
                                name={"telefono"}
                                value={state.telefono}
                                onChange={handleChange}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle password visibility"
                                            onClick={()=>window.open(`https://wa.me/${state.telefono}?text=${Strings.hola}, ${state.nombre}. `)}
                                            size="large">


                                            <WhatsApp/>
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <TextField
                            name="cuentaDestino"
                            value={state.cuentaDestino}
                            onChange={handleChange}
                            label={"Cuenta destino"}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <FormControl fullWidth>
                            <InputLabel>Paypal</InputLabel>
                            <Input
                                name={"suscriptionId"}
                                value={state.suscriptionId}
                                onChange={handleChange}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={()=>window.open("https://www.paypal.com/billing/subscriptions/"+state.suscriptionId)}
                                            size="large">
                                            <Launch/>
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <DateInput
                            name="proximoPago"
                            value={state.proximoPago}
                            label={Strings.proximo + " " + Strings.pago}
                            quincenalFijo={undefined}
                            onChange={handleChange}
                            required
                            fullWidth native={undefined} clearable={undefined} openTo={undefined} views={undefined}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            name="comentario"
                            label={Strings.comentario}
                            value={state.comentario}
                            onChange={handleChange}
                            rows={2}
                            multiline
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}><Typography color={"secondary"} variant={"h6"}>{Strings.reportes}</Typography></Grid>
                            <Grid item xs={6}>
                                <label>Titular Usuario: </label>
                                <b>{state.titularInicioSesion}</b>
                            </Grid>
                            <Grid item xs={6}>
                                <label>Titular Nombre: </label>
                                <b>{state.titularNombre}</b>
                            </Grid>
                            <Grid item xs={6}>
                                <label>Titular Teléfono: </label>
                                <b>{state.titularTelefono}</b>
                            </Grid>
                            <Grid item xs={6}>
                                <label>Fecha Registro: </label>
                                {formatDate(state.fechaCreacion,"DD MMM YYYY h:mm a")}
                            </Grid>
                            {/*<Grid item xs={6}>*/}
                            {/*    <label>Tipo: </label>*/}
                            {/*    {usuTipo?.value}*/}
                            {/*</Grid>*/}

                            <Grid item xs={6}>
                                <label>{Strings.clientes}: </label>
                                {state.clientesActivos}</Grid>
                            <Grid item xs={6}>
                                <label>{Strings.prestamosActivos}: </label>
                                {`${state.prestamosActivos} ${Strings.de} ${state.maxPrestamos}`}</Grid>
                            <Grid item xs={6} ><label>Pagos Realizados: </label>{state.pagosRealizados}</Grid>
                            {!!state.fechaUltimoPago &&
                                <Grid item xs={6}>
                                    <label>Ultimo pago: </label>{formatDate(state.fechaUltimoPago,"DD MMM YYYY h:mm a")}
                                </Grid>
                            }

                            {/*{!!state.usuOrderId &&*/}
                            {/*<Grid item xs={6}>*/}
                            {/*    <label>paypal OrderId: </label>*/}
                            {/*    {state.usuOrderId}</Grid>*/}
                            {/*}*/}
                            <Grid item xs={6}>
                                <label>Agentes: </label>
                                {state.agentes}</Grid>
                            <Grid item xs={6}>
                                <label>id: </label>
                                {state.id}</Grid>

                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}><Typography color={"secondary"} variant={"h6"}>Modulos</Typography></Grid>
                            {adminEnums.modulos?.map((item)=>
                                <Grid item  xs={6} md={3} key={item.key} >
                                    <FormControlLabel
                                        control={
                                            <StyledCheckbox
                                                checked={state.modulos?.some(p=>p.modulo === item.key)}
                                                onChange={(e:any)=>handleModuloCheck({key: item.key!, checked: e.target.checked})}
                                                color="primary"
                                                inputProps={{
                                                    'aria-label': 'primary checkbox',
                                                    // name: acc.key.toString(), //+ '_' + acc.key,
                                                }}
                                            />
                                        }
                                        label={item.value}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </Box>
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={openSnackbar}
            autoHideDuration={2000}
            onClose={()=>setOpenSnackbar(false)}
            message="Guardado con éxito!"
        />
    </>;

}
